import { mapState, mapGetters } from 'vuex';
import { GAME_LANUGAME } from '@store/officialWebStore/gameConf';
export default {
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      lang: state => state.lang
    }),
    extraTip() {
      return function () {
        const directGameExtra = {
          191: '10%'
        };
        if (directGameExtra[+this.gameId]) {
          return this.letter.gainPlus + directGameExtra[+this.gameId];
        }
      };
    },
    maxExtraRatio() {
      if (
        GAME_LANUGAME[this.gameId] &&
        GAME_LANUGAME[this.gameId][this.lang] &&
        GAME_LANUGAME[this.gameId][this.lang]['maxExtraRatio']
      ) {
        return GAME_LANUGAME[this.gameId][this.lang]['maxExtraRatio'];
      }
      return '';
    },
    ...mapGetters([
      'gameInfoConfig',
      'extraCoinIco',
      'subCoinIco',
      'productDefaultIco'
    ])
  }
};
